<script lang="ts">
    import cn from "classnames";

    let className = "";
    export { className as class };
</script>

<h1 class={cn("gw-page-title", className)}>
    <slot />
</h1>

<style lang="postcss" global>
    .gw-page-title {
        padding-top: 100px;
        font-family: "Montserrat";
        font-weight: 500;
        font-size: 40px;
        line-height: 48px;
        color: #3c3c3c;
        text-align: center;
        margin: 0;

        @media all and (max-width: 600px) {
            padding-top: 40px;
            font-size: 22px;
            line-height: 26px;
        }
    }
</style>
